export const GET_ALL_ENCOUNTERS = "GET_ALL_ENCOUNTERS";
